import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CenterModal from "../Components/CenterModal";
import API from "../../src/Services/Occasion";
import OccasionList from "./OccasionList";

const AddOccasion = () => {
    const [occasionname, setOccasionname] = useState("");
    const [date, setDate] = useState("");
    const [selectedCenter, setSelectedCenter] = useState([]);
    const [error, setError] = useState({});
    const[specialAmount, setSpecialAmount]=useState("");
    const[amount, setAmount]=useState("");

    const handleSelectedCenter = (data) => {
        setSelectedCenter(data);

        setError((prev) => {
            const updated = { ...prev };
            delete updated.selectedCenter;
            return updated;
        });
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (value.trim()) {
            setError((prev) => {
                const updated = { ...prev };
                delete updated[fieldName];
                return updated;
            });
        }
        switch (fieldName) {
            case "occasionname":
                setOccasionname(value);
                break;
            case "date":
                setDate(value);
                break;
                case "specialAmount":
                setSpecialAmount(value);
                break;
                case "amount":
                setAmount(value);
                break;
            default:
                break;
        }

    };

    const validateFields = () => {
        const errors = {};
        if (!occasionname.trim()) {
            errors.occasionname = "Occasion name is required";
        }

        if (!date.trim()) {
            errors.date = "Date is required";
        }

        if (!selectedCenter || selectedCenter.length === 0) {
            errors.selectedCenter = "Please select at least one center";
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };



    const handleSubmit = async () => {

        if (!validateFields()) return;
        try {
            const location_id = Array.isArray(selectedCenter)
                ? selectedCenter.join(", ")
                : selectedCenter;
            const payload = {
                date,
                location_id,
                name: occasionname
            };
            const response = await API.addNewOccasion(payload);

            if (response?.status === 200 || response?.status === 201) {
                toast.success(response?.data?.message || "Occasion added successfully!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to add occasion!");
            }

        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.response?.data?.message || error.message);
        }
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card mt-3">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Special Days Occasion</h4>

                        <div className="forms-sample">
                            <div className="row">

                                <div className="col-md-6">
                                    <label>
                                        Date <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={date}
                                        onChange={(e) => handleFieldChange(e, "date")}
                                        min={new Date().toISOString().split("T")[0]}
                                    />
                                    {error.date && (
                                        <small className="text-danger" style={{ fontSize: "12px" }}>
                                            {error.date}
                                        </small>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <CenterModal onSelectCenter={handleSelectedCenter} />
                                    {error.selectedCenter && (
                                        <small className="text-danger" style={{ fontSize: "12px" }}>
                                            {error.selectedCenter}
                                        </small>
                                    )}
                                </div>

                                <div className="col-md-6 mt-2">
                                    <label>
                                        Occasion Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        placeholder="Occasion Name"
                                        value={occasionname}
                                        onChange={(e) => handleFieldChange(e, "occasionname")}
                                    />
                                    {error.occasionname && (
                                        <small className="text-danger" style={{ fontSize: "12px" }}>
                                            {error.occasionname}
                                        </small>
                                    )}
                                </div>
                                 

                            </div>

                            <div className="mt-4">
                                <button className="btn btn-primary me-2" onClick={handleSubmit}>
                                    Submit
                                </button>
                                <button className="btn btn-light" onClick={() => window.location.reload()}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                   
                </div>

                <ToastContainer />

            </div>
             <OccasionList />
        </div>

    );
};

export default AddOccasion;
